export default class PlayNotComplete extends Error {
    constructor() {
        super("Play is not complete");
    }
}
